import type { ActionApi, ObjectTypeModalState } from '../../common/types.tsx';

export const setObjectTypeModalState =
	(newObjectTypeModalState: ObjectTypeModalState): ActionApi =>
	async ({ setState }) => {
		setState({ objectTypeModalState: newObjectTypeModalState });
	};
